import type { ReactNode } from 'react'
import React, { createContext, useContext, useState } from 'react'

interface SearchContextType {
  search: string
  setSearch: (search: string) => void
}

const SearchContext = createContext<SearchContextType | undefined>(undefined)

export const SearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [search, setSearch] = useState('')

  const value = { search, setSearch }

  return <SearchContext value={value}>{children}</SearchContext>
}

export function useSearch() {
  const context = useContext(SearchContext)
  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider')
  }
  return context
}
